const buttonNames = ["Читати далі", "Переглянути"]

export { buttonNames}